import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getAllTestsApi } from "../utils/constants";

export const getAllTest = createAsyncThunk("getAllTest", async (categoryId) => {
    try {
        const config = {
            headers: {
                Authorization: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImFhYXNzc0B5b3BtYWlsLmNvbSIsImlkIjoiNjM4YzhhYTUtYzU0NC00YzcxLWI3YWEtZTI2ZjBlOGZkNzFiIiwidXNlclR5cGUiOiJVU0VSIiwicGxhdGZvcm0iOiJXRUIiLCJpYXQiOjE3NDAzNzg0MjJ9.qTM6H1yVzhMhNDHsvdUHgcP22Oed8aX5hbFh_YwEW4",
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
            },
            params: {categoryId: categoryId},
        };
        const url = ApiBaseUrl + getAllTestsApi;
        const response = await axios.get(url, config);
        return response.data;
    } catch (error) {
        alert(error.response.data.message);
        throw error.response.data;
    }
});
const GetAllTestSlice = createSlice({
    name: "getAllTestReducer",
    initialState: {
        isLoading: false,
        data: null,
    },
    reducers: {
        clearGetAllTestData: (state) => {
            state.data = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllTest.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllTest.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
            })
            .addCase(getAllTest.rejected, (state) => {
                state.isError = false;
            });
    },
});

export const { clearGetAllTestData } = GetAllTestSlice.actions;
export default GetAllTestSlice.reducer;